// ============================================================================
// BRANCH ENDPOINTS
// ============================================================================
// BASE_PATH must match the backend controller route token (BranchController → /Branch).

import { buildEndpoint, buildEndpointWithParams } from './base.endpoints';
import type { ID } from '../types';

export const BRANCH_BASE_PATH = '/Branch';

export const branchEndpoints = {
  list: () => buildEndpoint(BRANCH_BASE_PATH),
  getById: (id: ID) => buildEndpointWithParams(`${BRANCH_BASE_PATH}/:id`, { id }),
  getByCode: (code: string) => buildEndpointWithParams(`${BRANCH_BASE_PATH}/code/:code`, { code }),
  create: () => buildEndpoint(BRANCH_BASE_PATH),
  update: (id: ID) => buildEndpointWithParams(`${BRANCH_BASE_PATH}/:id`, { id }),
  delete: (id: ID) => buildEndpointWithParams(`${BRANCH_BASE_PATH}/:id`, { id }),
  validateCode: (code: string) => buildEndpointWithParams(`${BRANCH_BASE_PATH}/validate/code/:code`, { code }),
} as const;

export default branchEndpoints;
